import { render, staticRenderFns } from "./AdminProdControl.vue?vue&type=template&id=a6135046&"
import script from "./AdminProdControl.vue?vue&type=script&lang=js&"
export * from "./AdminProdControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports